<template>
  <div class="realTaskMenu">
    <div class="menuHerder"></div>
    <div class="menuBodyDad">
      <div class="menuBody">
        <p style="color: #999999">智能审计</p>
        <p>真实任务</p>
      </div>
      <div class="menuFoot">
        <div
          class="tabStyle"
          @click="cut(1)"
          :class="cut_result == 1 ? 'selectStyle' : ''"
        >
          <div class="selectStyle1">
            <p>班级企业管理</p>
          </div>
        </div>
        <div
          class="tabStyle"
          @click="cut(2)"
          :class="cut_result == 2 ? 'selectStyle' : ''"
        >
          <div class="selectStyle1">
            <p>项目总包管理</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:["cutValue"],
  data() {
    return {
      cut_result: 1,
    };
  },
  created(){
    this.cut_result = this.cutValue
  },
  methods: {
    cut(a) {
      this.cut_result = a
      this.$emit("cut",this.cut_result)
    },
  },
};
</script>

<style  lang="scss">
  .realTaskMenu {
    background: #f9f9fa;
    padding: 20px;
    .menuHerder {
      height: 115px;
      width: 200px;
      background: url("https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.2008php.com%2F09_Website_appreciate%2F10-07-11%2F1278861720_g.jpg&refer=http%3A%2F%2Fwww.2008php.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1652858106&t=628f1b20d60463d14ae96befab78ce51")
      no-repeat;
      background-size: 100% 100%;
      border-radius: 10px;
    }
    .menuBodyDad {
      cursor: pointer;
      text-align: center;
      font-size: 12px;
      .menuBody {
        background: white;
        width: 200px;
        height: 30px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          margin: 10px;
        }
      }
    }
    .menuFoot {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      .tabStyle {
        height: 50px;
        width: 200px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          color: gray;
        }
      }

      .selectStyle1 {
        cursor: pointer;
        width: 190px;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .selectStyle1:hover {
        cursor: pointer;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f6fdff;
      }
      .selectStyle {
        /**/
        .selectStyle1:hover {
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgb(217, 236, 255);
        }
        cursor: pointer;
        background: rgb(217, 236, 255);

        p {
          color: black;
          font-weight: 600;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/auditNewRealTask/components/realTaskMenu.vue